import React from 'react'
import styled from 'styled-components'
import HeroSection from './HomeSection/HeroSection'
import { Helmet } from "react-helmet";
import StartUp from './HomeSection/StartUp';
import ScaleUp from './HomeSection/ScaleUp';

const LandingPage = () => {
  return (
    <>
      <Helmet>
        <title>Medichy | Home</title>
        <meta
          name="description"
          content="Medichy offers comprehensive medical device design services with expertise in minimally invasive devices, catheter technologies, and regulatory compliance."
        />
      </Helmet>
      <TheLandingPage>
        <HeroSection />
        <StartUp />
        <ScaleUp/>
      </TheLandingPage>
    </>
  );
}


const TheLandingPage = styled.div`
    
`
export default LandingPage